import { get } from 'lodash-es';

export const messages = {
  'en': {
    accept: 'Yes',
    addRule: 'Add Rule',
    am: 'AM',
    apply: 'Apply',
    cancel: 'Cancel',
    choose: 'Choose',
    chooseDate: 'Choose Date',
    chooseMonth: 'Choose Month',
    chooseYear: 'Choose Year',
    clear: 'Clear',
    completed: 'Completed',
    contains: 'Contains',
    custom: 'Custom',
    dateAfter: 'Date is after',
    dateBefore: 'Date is before',
    dateFormat: 'mm/dd/yy',
    dateIs: 'Date is',
    dateIsNot: 'Date is not',
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    emptyFilterMessage: 'No results found',
    emptyMessage: 'No available options',
    emptySearchMessage: 'No results found',
    emptySelectionMessage: 'No selected item',
    endsWith: 'Ends with',
    equals: 'Equals',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    filter: 'Filter',
    firstDayOfWeek: 0,
    gt: 'Greater than',
    gte: 'Greater than or equal to',
    lt: 'Less than',
    lte: 'Less than or equal to',
    matchAll: 'Match All',
    matchAny: 'Match Any',
    medium: 'Medium',
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    nextDecade: 'Next Decade',
    nextHour: 'Next Hour',
    nextMinute: 'Next Minute',
    nextMonth: 'Next Month',
    nextSecond: 'Next Second',
    nextYear: 'Next Year',
    noFilter: 'No Filter',
    notContains: 'Not contains',
    notEquals: 'Not equals',
    now: 'Now',
    passwordPrompt: 'Enter a password',
    pending: 'Pending',
    pm: 'PM',
    prevDecade: 'Previous Decade',
    prevHour: 'Previous Hour',
    prevMinute: 'Previous Minute',
    prevMonth: 'Previous Month',
    prevSecond: 'Previous Second',
    prevYear: 'Previous Year',
    reject: 'No',
    removeRule: 'Remove Rule',
    searchMessage: '{0} results are available',
    selectionMessage: '{0} items selected',
    showMonthAfterYear: false,
    startsWith: 'Starts with',
    strong: 'Strong',
    today: 'Today',
    upload: 'Upload',
    weak: 'Weak',
    weekHeader: 'Wk',
    aria: {
      cancelEdit: 'Cancel Edit',
      close: 'Close',
      collapseLabel: 'Collapse',
      collapseRow: 'Row Collapsed',
      editRow: 'Edit Row',
      expandLabel: 'Expand',
      expandRow: 'Row Expanded',
      falseLabel: 'False',
      filterConstraint: 'Filter Constraint',
      filterOperator: 'Filter Operator',
      firstPageLabel: 'First Page',
      gridView: 'Grid View',
      hideFilterMenu: 'Hide Filter Menu',
      jumpToPageDropdownLabel: 'Jump to Page Dropdown',
      jumpToPageInputLabel: 'Jump to Page Input',
      lastPageLabel: 'Last Page',
      listView: 'List View',
      moveAllToSource: 'Move All to Source',
      moveAllToTarget: 'Move All to Target',
      moveBottom: 'Move Bottom',
      moveDown: 'Move Down',
      moveToSource: 'Move to Source',
      moveToTarget: 'Move to Target',
      moveTop: 'Move Top',
      moveUp: 'Move Up',
      navigation: 'Navigation',
      next: 'Next',
      nextPageLabel: 'Next Page',
      nullLabel: 'Not Selected',
      otpLabel: 'Please enter one time password character {0}',
      pageLabel: 'Page {page}',
      passwordHide: 'Hide Password',
      passwordShow: 'Show Password',
      previous: 'Previous',
      previousPageLabel: 'Previous Page',
      removeLabel: 'Remove',
      rotateLeft: 'Rotate Left',
      rotateRight: 'Rotate Right',
      rowsPerPageLabel: 'Rows per page',
      saveEdit: 'Save Edit',
      scrollTop: 'Scroll Top',
      selectAll: 'All items selected',
      selectLabel: 'Select',
      selectRow: 'Row Selected',
      showFilterMenu: 'Show Filter Menu',
      slide: 'Slide',
      slideNumber: '{slideNumber}',
      star: '1 star',
      stars: '{star} stars',
      trueLabel: 'True',
      unselectAll: 'All items unselected',
      unselectLabel: 'Unselect',
      unselectRow: 'Row Unselected',
      zoomImage: 'Zoom Image',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',

    },
  },
  'pt-BR': {
    accept: 'Sim',
    addRule: 'Adicionar Regra',
    am: 'AM',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    choose: 'Escolher',
    chooseDate: 'Escolher Data',
    chooseMonth: 'Escolher Mês',
    chooseYear: 'Escolher Ano',
    clear: 'Limpar',
    completed: 'Concluído',
    contains: 'Contém',
    custom: 'Personalizado',
    dateAfter: 'Data depois de',
    dateBefore: 'Data antes de',
    dateFormat: 'dd/mm/yy',
    dateIs: 'Data é',
    dateIsNot: 'Data não é',
    dayNames: [
      'Domingo',
      'Segunda-feira',
      'Terça-feira',
      'Quarta-feira',
      'Quinta-feira',
      'Sexta-feira',
      'Sábado',
    ],
    dayNamesMin: [
      'D',
      'S',
      'T',
      'Q',
      'Q',
      'S',
      'S',
    ],
    dayNamesShort: [
      'Dom',
      'Seg',
      'Ter',
      'Qua',
      'Qui',
      'Sex',
      'Sáb',
    ],
    emptyFilterMessage: 'Nenhum resultado encontrado',
    emptyMessage: 'Nenhuma opção disponível',
    emptySearchMessage: 'Nenhum resultado encontrado',
    emptySelectionMessage: 'Nenhum item selecionado',
    endsWith: 'Termina com',
    equals: 'Igual',
    fileSizeTypes: [
      'B',
      'KB',
      'MB',
      'GB',
      'TB',
      'PB',
      'EB',
      'ZB',
      'YB',
    ],
    filter: 'Filtro',
    firstDayOfWeek: 0,
    gt: 'Maior que',
    gte: 'Maior ou igual a',
    lt: 'Menor que',
    lte: 'Menor ou igual a',
    matchAll: 'Corresponder Todos',
    matchAny: 'Corresponder Qualquer',
    medium: 'Médio',
    monthNames: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    monthNamesShort: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    nextDecade: 'Próxima Década',
    nextHour: 'Próxima Hora',
    nextMinute: 'Próximo Minuto',
    nextMonth: 'Próximo Mês',
    nextSecond: 'Próximo Segundo',
    nextYear: 'Próximo Ano',
    noFilter: 'Sem Filtro',
    notContains: 'Não contém',
    notEquals: 'Diferente',
    now: 'Agora',
    passwordPrompt: 'Digite uma senha',
    pending: 'Pendente',
    pm: 'PM',
    prevDecade: 'Década Anterior',
    prevHour: 'Hora Anterior',
    prevMinute: 'Minuto Anterior',
    prevMonth: 'Mês Anterior',
    prevSecond: 'Segundo Anterior',
    prevYear: 'Ano Anterior',
    reject: 'Não',
    removeRule: 'Remover Regra',
    searchMessage: 'Existem {0} resultados disponíveis',
    selectionMessage: '{0} itens selecionados',
    showMonthAfterYear: false,
    startsWith: 'Começa com',
    strong: 'Forte',
    today: 'Hoje',
    upload: 'Enviar',
    weak: 'Fraco',
    weekHeader: 'Sem',
    aria: {
      cancelEdit: 'Cancelar Edição',
      close: 'Fechar',
      collapseLabel: 'Colapso',
      collapseRow: 'Recolher Linha',
      editRow: 'Editar Linha',
      expandLabel: 'Expandir',
      expandRow: 'Expandir Linha',
      falseLabel: 'Falso',
      filterConstraint: 'Restrição de Filtro',
      filterOperator: 'Operador de Filtro',
      firstPageLabel: 'Primeira Página',
      gridView: 'Visualização de Grade',
      hideFilterMenu: 'Esconder Menu de Filtro',
      jumpToPageDropdownLabel: 'Ir para a Página',
      jumpToPageInputLabel: 'Ir para a Página',
      lastPageLabel: 'Última Página',
      listView: 'Visualização de Lista',
      moveAllToSource: 'Mover Todos para a Origem',
      moveAllToTarget: 'Mover Todos para o Destino',
      moveBottom: 'Mover para o Final',
      moveDown: 'Mover para Baixo',
      moveTop: 'Mover para o Topo',
      moveToSource: 'Mover para a Origem',
      moveToTarget: 'Mover para o Destino',
      moveUp: 'Mover para Cima',
      navigation: 'Navegação',
      next: 'Próximo',
      nextPageLabel: 'Próxima Página',
      nullLabel: 'Não Selecionado',
      otpLabel: 'Insira o caractere da senha de uso único {0}',
      pageLabel: 'Página {page}',
      passwordHide: 'Esconder a senha',
      passwordShow: 'Mostrar senha',
      previous: 'Anterior',
      previousPageLabel: 'Página Anterior',
      removeLabel: 'Remover',
      rotateLeft: 'Rotacionar para a Esquerda',
      rotateRight: 'Rotacionar para a Direita',
      rowsPerPageLabel: 'Linhas por página',
      saveEdit: 'Salvar Edição',
      scrollTop: 'Rolar para o Topo',
      selectAll: 'Todos os itens selecionados',
      selectLabel: 'Selecione',
      selectRow: 'Linha Selecionada',
      showFilterMenu: 'Mostrar Menu de Filtro',
      slide: 'Deslizar',
      slideNumber: 'Slide {slideNumber}',
      star: '1 estrela',
      stars: '{star} estrelas',
      trueLabel: 'Verdadeiro',
      unselectAll: 'Todos os itens desmarcados',
      unselectLabel: 'Desmarcar',
      unselectRow: 'Linha Desmarcada',
      zoomImage: 'Ampliar Imagem',
      zoomIn: 'Ampliar',
      zoomOut: 'Reduzir',
    },
  },
};

export function getMessagesByLang(lang: string) {
  const messageObject = get(messages, lang) as Record<string, unknown>;
  return messageObject ?? messages.en;
}
